import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Privacy = () => (
  <div className="min-h-screen">
    <Header />
    <main id="main-content" className="pt-24 pb-16 container mx-auto px-4 max-w-4xl">
      <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
      <div className="prose prose-lg text-muted-foreground space-y-6">
        <p><strong>Last updated:</strong> February 2026</p>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Who We Are</h2>
          <p>This website is operated by:</p>
          <p>
            Coblynau IT Solutions<br />
            Swansea, Wales, United Kingdom<br />
            Email:{" "}
            <a href="mailto:info@coblynausolutions.co.uk" className="text-primary hover:underline">
              info@coblynausolutions.co.uk
            </a>
          </p>
          <p>We are the data controller responsible for your personal information.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">What Information We Collect</h2>

          <h3 className="text-xl font-semibold text-foreground mt-4">Information you provide</h3>
          <ul className="list-disc pl-6">
            <li>Name</li>
            <li>Email address</li>
            <li>Telephone number (if provided)</li>
            <li>Details included in your enquiry or message</li>
          </ul>

          <h3 className="text-xl font-semibold text-foreground mt-4">Website Technical Information</h3>
          <p>
            When you visit our website, limited technical information may be processed automatically
            to ensure the website functions correctly and securely.
          </p>
          <p>We do not use website analytics, tracking tools, or visitor monitoring technologies.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="list-disc pl-6">
            <li>Respond to enquiries</li>
            <li>Provide information about our services</li>
            <li>Maintain the security and operation of the website</li>
          </ul>
          <p>We do not sell your personal data.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Legal Basis</h2>
          <p>We rely on the following lawful basis:</p>
          <ul className="list-disc pl-6">
            <li>
              <strong>Legitimate interests</strong> – to respond to enquiries and operate our business
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Data Sharing</h2>
          <p>
            We use trusted third-party service providers to support the operation of our website and
            business, including website hosting, platform services, and email or IT support.
          </p>
          <p>
            These providers process personal data only on our behalf and in accordance with data
            protection law.
          </p>
          <p>
            Some providers may process data outside the UK. Where this occurs, appropriate safeguards
            are in place.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">How Long We Keep Data</h2>
          <p>
            Enquiry information is typically retained for up to 12–24 months, unless a longer period
            is required for ongoing business or legal purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6">
            <li>Access your personal data</li>
            <li>Request correction or deletion</li>
            <li>Object to or restrict processing</li>
          </ul>
          <p>
            You also have the right to complain to the Information Commissioner's Office:{" "}
            <a
              href="https://ico.org.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              ico.org.uk
            </a>
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Cookies</h2>
          <p>
            For information about how we use cookies, please see our{" "}
            <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Contact</h2>
          <p>If you have any questions about this Privacy Policy, please contact:</p>
          <p>
            Coblynau IT Solutions<br />
            Email:{" "}
            <a href="mailto:info@coblynausolutions.co.uk" className="text-primary hover:underline">
              info@coblynausolutions.co.uk
            </a>
          </p>
        </section>
      </div>
    </main>
    <Footer />
  </div>
);

export default Privacy;
